import { useQuery, UseQueryOptions } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient"

export const useFindDocumentUrlQuery = (
  documentId: string | null,
  options?: Omit<UseQueryOptions<string>, "queryKey" | "queryFn">
) =>
  useQuery<string>({
    ...options,
    queryKey: ["documentUrl", documentId],
    queryFn: async () => {
      const response = await httpClient.get(`/documents/${documentId}`)
      return response.data.url
    },
    retry: false,
    enabled: !!documentId,
  })

export const fetchDocumentUrl = async (
  documentId: string | null,
  download?: boolean
) => {
  if (!documentId) {
    return null
  }
  return queryClient.fetchQuery({
    queryKey: ["documentUrl", documentId],
    queryFn: async () => {
      const response = await httpClient.get(`/documents/${documentId}`, {
        params: {
          download,
        },
      })
      return response.data.url
    },
  })
}
